import { useDispatch } from 'react-redux';
import * as storeActions from '../store/actions';

/**
 * @description - this hook used to bind all actions to dispatch method
 * @returns {Object} - object with all available actions
 */
export const useReduxActions = () => {
  const dispatch = useDispatch();
  return Object.keys(storeActions).reduce((acc, action) => {
    acc[action] = (...data) => dispatch(storeActions[action](...data));
    return acc;
  }, {});
};
